var icon = require('vue-svgicon');
// console.log('');
icon.register({
  'quote': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: `<path pid="0" d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"/>`
  }
});



// WEBPACK FOOTER //
// ./src/icons/quote.js